import type {
  FeatureFlag,
  OrgFeatureFlag,
  RolloutRequest,
  RolloutResponse,
  SetOrgFeatureFlagsRequest,
  UpdateFeatureFlagRequest,
} from '@/definitions/featureFlags'
import api from '@/services/api'

export const FetchFeatureFlags = async (): Promise<FeatureFlag[]> => {
  const response = await api.get<FeatureFlag[]>('/api/v1/feature-flags')
  return response.data
}

/** Replaces a flag's whole set of global switches. */
export const UpdateFeatureFlag = async (
  name: string,
  data: UpdateFeatureFlagRequest
): Promise<FeatureFlag> => {
  const response = await api.put<FeatureFlag>(`/api/v1/feature-flags/${name}`, data)
  return response.data
}

/**
 * Turns one flag on or off across a set of organizations.
 *
 * Answers 200 with a per-organization outcome even when some were not moved —
 * which organizations landed is the result, not an error — so the caller must
 * read `results` rather than treat a resolved promise as success.
 */
export const RollOutFeatureFlag = async (
  name: string,
  data: RolloutRequest
): Promise<RolloutResponse> => {
  const response = await api.post<RolloutResponse>(`/api/v1/feature-flags/${name}/rollout`, data)
  return response.data
}

export const FetchOrgFeatureFlags = async (orgId: string): Promise<OrgFeatureFlag[]> => {
  const response = await api.get<OrgFeatureFlag[]>(`/api/v1/feature-flags/organizations/${orgId}`)
  return response.data
}

/**
 * Turns flags on and off for one organization, returning every flag's state.
 *
 * The response is the whole set rather than the names asked for: a name that
 * could not be moved comes back carrying the state that explains why.
 */
export const SetOrgFeatureFlags = async (
  orgId: string,
  data: SetOrgFeatureFlagsRequest
): Promise<OrgFeatureFlag[]> => {
  const response = await api.post<OrgFeatureFlag[]>(`/api/v1/feature-flags/organizations/${orgId}`, data)
  return response.data
}
